import axios from 'axios';

const baseUrl = process.env.REACT_APP_AWS_API_GATEWAY_URL
const baseUrlEF = process.env.REACT_APP_AWS_API_GATEWAY_URL_EXECUTE_FLOW;
const flowIdSaveAndSendOC = process.env.REACT_APP_FLOWID_SEND_AND_SAVE_OC;

export const insert = (accessToken, obj) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type':'application/json'
        },
        data: JSON.stringify({
            'process': 'electronic_documents_alter',
            'action': 'INSERT',
            'variables': obj
        })
    })
};

export const getUsers = (accessToken, idCompany) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'user_select',
            'action': 'APPROVER_OC',
            'variables': JSON.stringify({ 'id_company': idCompany })
        })
    })
}

export const getRoles = (accessToken, idCompany) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'user_select',
            'action': 'SELECTGROUPS_OC',
            'variables': JSON.stringify({ 'id_company': idCompany })
        })
    })
}
export const getWareHouses = (accessToken, idCompany) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'order_reference_select',
            'action': 'SELECT_WAREHOUSES',
            'variables': JSON.stringify({ 'id_company': idCompany })
        })
    })
}


export const getCompanies = (id_user_action, accessToken) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'user_select',
            'action': 'SELECTCOMPANIES_OC',
            'variables': JSON.stringify({ 'id_user_action': id_user_action })
        })
    })
};
export const update = (obj, accessToken) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type':'application/json'
        },
        data: JSON.stringify({
            'process': 'electronic_documents_alter',
            'action': 'UPDATE',
            'variables': obj
        })
    })
};

export const fetchInvoiceId = (id, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': "electronic_documents_select",
            'action': "SELECT_BY_ID",
            // "findOne": "true",
            'variables': JSON.stringify({id})
        })
    });
};
export const fetchProductsInvoice = (id, accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            process: "electronic_documents_details_select",
            action: "SELECT_BY_ID",
            variables: JSON.stringify({id})
        })
    });
};

export const fetchSendInvoice = (accessToken, id, action) => {
    return axios({
        method: 'POST',
        url: baseUrlEF,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({ "id_flow": "SEND_ELECTRONIC_DOCUMENT_INVOICE", "id_electronic_document": id, "action": action })
    })
}